import { ngXUrls } from '../../../../../../src/app/config/url.handling';

class TrialNotification {
  [x: string]: any;
  static $inject = ['moment', 'DateFormat', 'AuthService', '$state', '$transitions', 'LanguageService', 'Router'];

  constructor(moment, DateFormat, AuthService, $state, $transitions, LanguageService, Router) {
    this.moment = moment;
    this.DateFormat = DateFormat;
    this.dangerLimit = 24 * 5;
    this.AuthService = AuthService;
    this.LanguageService = LanguageService;
    this.$state = $state;
    this.$transitions = $transitions;
    this.isTrialBannerClosedByUser = false;
    this.router = Router;
  }

  $onInit() {
    const expiredDate = this.moment.utc(this.trialExpirationDate, this.DateFormat.localDateTimePattern);
    const statesToHideTrialBanner = [
      'app.blacklist', 'app.lead-generation', 'app.lead-generationPath', 'app.campaign.dashboard',
      'app.campaign.settings', 'app.campaign.import.upload', 'app.campaign.import.history', 'app.numbers.settings',
      'app.pricing', 'app.contacts'
    ];
    const checkIfLessSpaceOnCurrentUrl = () => statesToHideTrialBanner.includes(this.$state.current.name);
    this.hours = expiredDate.diff(this.moment(), 'hours');
    this.notificationLabel = this.moment.duration(this.hours, "hours").humanize();
    [this.timeRemaining, this.timeUnit] = this.notificationLabel.split(' ');
    this.isInDanger = this.hours < this.dangerLimit;
    this.setTrialStatus({inDanger: this.isInDanger, label: this.notificationLabel});
    this.shouldShowOnlyForBigScreens = checkIfLessSpaceOnCurrentUrl();
    this.$transitions.onSuccess({ }, () => {
      this.shouldShowOnlyForBigScreens = checkIfLessSpaceOnCurrentUrl();
    });

    this.LanguageService.onLanguageChange.subscribe(() => {
      this.notificationLabel = this.moment.duration(this.hours, "hours").humanize();
      [this.timeRemaining, this.timeUnit] = this.notificationLabel.split(' ');
    });
  }

  isLinkVisible() {
    return this.AuthService.hasPermission("PLANS_PERMISSION");
  }

  closeTrialBanner() {
    this.isTrialBannerClosedByUser = true;
    this.setBannerClosed();
  }

  goToChoosePlan() {
    this.router.navigateByUrl('/choose-plan');
  }
}

export default {
  controller: TrialNotification,
  template: require('./trial.html'),
  bindings: {
    trialExpirationDate: '<',
    setTrialStatus: '&'
  }
};
